import React, { useState, useEffect } from 'react';
import classes from "./questionTypes.module.css";
import util from "../../../../styles/utilities.module.css";

const QuestionCount = ({ name, initialValue, incrementDecrement, selectedWorksheet }) => {
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const getMinimumValue = () => {
    if (name === 'sippsLesson') {
      switch (selectedWorksheet) {
        case 1:
          return 4;
        case 2:
          return 11;
        default:
          return 0;  // Default minimum for other worksheets or undefined cases
      }
    }
    return 0;  // Return 0 for types other than 'sippsLesson'
  };

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    setInputValue(newValue);
  };

  const handleBlur = () => {
    let normalizedValue = parseInt(inputValue, 10);
    const maxValues = {
      multipleChoice: 20,
      sippsLesson: 55,
    };
    const max = maxValues[name] || 10;
    const min = getMinimumValue();
    normalizedValue = isNaN(normalizedValue) ? min : Math.max(min, Math.min(normalizedValue, max));
    setInputValue(normalizedValue);
    incrementDecrement(name, normalizedValue);
  };

  const handleIncrement = () => {
    const maxValues = {
      multipleChoice: 20,
      sippsLesson: 55,
    };
    const max = maxValues[name] || 10;
    const newValue = Math.min(inputValue + 1, max);
    setInputValue(newValue);
    incrementDecrement(name, newValue);
  };

  const handleDecrement = () => {
    const min = getMinimumValue();
    const newValue = Math.max(min, inputValue - 1);
    setInputValue(newValue);
    incrementDecrement(name, newValue);
  };

  const maxValues = {
    multipleChoice: 20,
    sippsLesson: 55,
  };
  const max = maxValues[name] || 10;
  const min = getMinimumValue();

  return (
    <div className={classes.addMinusSection}>
      <button
        type="button"
        onClick={handleDecrement}
        className={`${util['btn-step']} ${util['btn-step--minus']}`}
        disabled={inputValue === min}
      >
        -
      </button>
      <input
        type="number"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        className={classes.valueInput}
        min={min}
        max={max}
      />
      <button
        className={util['btn-step']}
        type="button"
        onClick={handleIncrement}
        disabled={inputValue === max}
      >
        +
      </button>
    </div>
  );
};

export default QuestionCount;
